import React from 'react';
import s from '../../pages/PDV.module.css';

export default function ModalFecharCaixa({ modalFecharCaixa, setModalFecharCaixa, turnoAtual, saldoFechamento, setSaldoFechamento, erroFechamento, fechandoCaixa, fecharCaixa }) {
  if (!modalFecharCaixa) return null;
  return (
        <div className={s.modalOverlay} onClick={() => setModalFecharCaixa(false)}>
          <div onClick={e => e.stopPropagation()} style={{
            background: '#fff', borderRadius: 10, padding: 28, width: 380,
            boxShadow: '0 8px 40px rgba(0,0,0,0.35)', fontFamily: 'Tahoma, sans-serif',
          }}>
            <div style={{ fontSize: 15, fontWeight: 'bold', marginBottom: 18, color: '#1e3a5f' }}>
              Fechar Caixa — Turno #{turnoAtual?.id}
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ fontSize: 12, color: '#444', display: 'block', marginBottom: 4 }}>
                Saldo em Caixa — total de dinheiro contado (R$)
              </label>
              <input
                type="text" inputMode="decimal"
                value={saldoFechamento}
                onChange={e => setSaldoFechamento(e.target.value)}
                onFocus={e => e.target.select()}
                onKeyDown={e => e.key === 'Enter' && fecharCaixa()}
                autoFocus
                placeholder="0,00"
                style={{
                  width: '100%', padding: '9px 12px', fontSize: 20,
                  fontWeight: 'bold', textAlign: 'right',
                  border: '2px solid #fca5a5', borderRadius: 6,
                  boxSizing: 'border-box', color: '#b91c1c',
                }}
              />
              <p style={{ margin: '4px 0 0', fontSize: 11, color: '#888' }}>
                Informe o total físico de dinheiro no caixa. Pode deixar em branco.
              </p>
            </div>
            {erroFechamento && (
              <div style={{
                background: '#fee2e2', color: '#b91c1c', borderRadius: 5,
                padding: '6px 10px', fontSize: 13, marginBottom: 12,
              }}>
                {erroFechamento}
              </div>
            )}
            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button
                onClick={() => setModalFecharCaixa(false)}
                disabled={fechandoCaixa}
                style={{
                  padding: '8px 18px', fontSize: 14, cursor: 'pointer',
                  border: '1px solid #ccc', borderRadius: 6, background: '#f5f5f5',
                }}
              >Cancelar</button>
              <button
                onClick={fecharCaixa}
                disabled={fechandoCaixa}
                style={{
                  padding: '8px 22px', fontSize: 14, fontWeight: 'bold', cursor: 'pointer',
                  border: 'none', borderRadius: 6,
                  background: fechandoCaixa ? '#fca5a5' : '#dc2626', color: '#fff',
                }}
              >{fechandoCaixa ? 'Fechando...' : '✔ Fechar Caixa'}</button>
            </div>
          </div>
        </div>
  );
}
